// Shared Chart.js formatters for currency axes and tooltips. Used by
// any controller rendering a financial chart — keeps the "$123K" /
// "$1,234,567" styling consistent across dashboards and avoids
// per-controller copies drifting out of sync.

export function formatShortCurrency(v) {
  if (v === null || v === undefined) return ""
  const abs = Math.abs(v)
  if (abs >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`
  if (abs >= 1_000) return `$${(v / 1_000).toFixed(0)}K`
  return `$${Math.round(v)}`
}

export function formatCurrency(v) {
  if (v === null || v === undefined) return "—"
  return `$${Math.round(v).toLocaleString()}`
}
